import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { clsx as cx } from 'clsx';
import * as styles from './QuestionLayoutBodyModerationIssues.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuestionLayoutBodyModerationIssues = function QuestionLayoutBodyModerationIssues(props) {
  var deviceType = useDeviceType();
  var _props$layoutType = props.layoutType,
    layoutType = _props$layoutType === void 0 ? 'default' : _props$layoutType,
    issues = props.issues;
  return /*#__PURE__*/_jsx("ul", {
    className: cx(styles['list'], styles["list--".concat(deviceType)], styles["list--".concat(layoutType)]),
    "data-testid": "questionLayoutBodyModerationIssues",
    children: issues.map(function (issue, index) {
      return /*#__PURE__*/_jsxs("li", {
        className: styles['list-item'],
        children: [/*#__PURE__*/_jsx("div", {
          className: styles['item-title'],
          children: issue.title
        }), /*#__PURE__*/_jsx("div", {
          dangerouslySetInnerHTML: {
            __html: issue.text
          }
        })]
      }, index);
    })
  });
};